import { getSelfServiceLabel } from "../../utils/getSelfServiceLabel";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { useCommonData } from "../layout/CommonDataProvider";

export const useSelfServiceLabel = () => {
  const { site } = useCommonData();
  const { lang } = useTranslation();
  return getSelfServiceLabel(lang, site);
};
